@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/breakpoints";
@use "@inshared/ui-foundation/css/tokens/spacing";
@use "@inshared/ui-foundation/css/tokens/size";

.web-search {
    display: flex;
    flex-direction: column;
    width: 100%;

    .message {
        margin-top: var(--spacing-md);
        font-style: italic;
        font-size: var(--font-size-small);
    }

    .results {
        margin-top: var(--spacing-lg);
        display: grid;
        grid-template-columns: 1fr;
        gap: var(--spacing-lg);

        @media (min-width: breakpoints.$screen-lg-min) {
            grid-template-columns: 1fr 1fr 1fr 1fr;
        }
    }

    .search {
        position: relative;

        web-icon {
            --icon-height: #{size.$icon-lg};
            --icon-width: #{size.$icon-lg};
            height: 2.4rem;
            position: absolute;
            right: 1rem;
            top: 50%;
            color: color.$color-primary;
            transform: translateY(-50%);
            pointer-events: none;
        }
    }

    input {
        width: 100%;
    }

    button {
        margin-top: spacing.$xl;
    }
}
